$(document).ready(function(){
  


    // Accordion

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].onclick = function(){
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("show-acc");
        }
    }
  
  
    // Terms accept validation

    function checkForm(form) {
      if(!form.terms.checked) {
        alert("Please accept the Terms and Conditions");
        form.terms.focus();
        return false;
      }
      return true;
    }
  
  
  	// Menu Toggle
  
	$('.main-menu-link').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('.main-menu').toggleClass('open');
        $('body').toggleClass('overlay-on');
	});
 
  
  	// Add no. to menu item
  
    var n = 1;
  	$('#overlay-menu .site-nav__expanded-item').each(function() {
  		$( this ).find('span').html('0'+n);
      	n++;
	});
  
 
    // Hero cta scroll to product
  
    $('.btn.hero__cta').on('click', function(e){
      e.preventDefault();
      
      $('body,html').animate({
        scrollTop: $('#sectionfive').position().top
      }, 'slow');
    });
  
  
  	// Down arrow scroll to next section
  
    $('.down-arrow').on('click', function(e){
      e.preventDefault();
      var nextSection = $(this).closest('.section').next();
      $('body,html').animate({
        scrollTop: nextSection.position().top
      }, 'slow');
    });
  	
  	
    // Back to top
  
  	$('.back-to-top').on('click', function(e){
      e.preventDefault(); 
      $('body,html').animate({
        scrollTop: 0
      }, 'slow');
    });

  $('#stamped-reviews-widget').on('click', function(e){
      e.preventDefault(); 
      $('body,html').animate({
        scrollTop: $('#stamped-main-widget').position().top
      }, 'slow');
    });

  
  
  
  
  
  
    //  Load svg code
  
    jQuery('img.svg').each(function(){
      var $img = jQuery(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      jQuery.get(imgURL, function(data) {
          // Get the SVG tag, ignore the rest
          var $svg = jQuery(data).find('svg');

          // Add replaced image's ID to the new SVG
          if(typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
          }
          // Add replaced image's classes to the new SVG
          if(typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass+' replaced-svg');
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr('xmlns:a');

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
              $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
          }

          // Replace image with new SVG
          $img.replaceWith($svg);

      }, 'xml');

    });
  
  
	// Cookie consent button resize
  
  	if ($('.cc_banner').length) {
      $(window).on('resize', cookie_height);
      function cookie_height() {
          var cookie_h = $('.cc_banner').height() + 30;
          $('.cc_btn').css('height', cookie_h);
      }
    }

	// Preloader
  
    $(window).load(function() {
       $("#loading").fadeOut(500);
    })
  
  
	// Dot navigation
  
  	var amount_sections = $('.section').length;
	var i = 1;
    $('.section').each(function() {
      	$('.dot-nav').append('<a href="#'+$(this).attr('id')+'" data-index="'+i+'" data-id="'+$(this).attr('id')+'"><span>'+i+'</span></a>');
      	i++;
    });

    $('.dot-nav a').on('click', function(e){
      e.preventDefault();
      
      var the_section = $(this).data('id');
      
      $('body,html').animate({
        scrollTop: $('#'+the_section+'.section').position().top
      }, 'slow');
      
    });
  
  	var contentSections = $('.section'),
		navigationItems = $('.dot-nav a');
 
  	updateNavigation();
	$(window).on('scroll', function(){
		updateNavigation();
	});
  
  	function updateNavigation() {
		contentSections.each(function(){
			$this = $(this);
			var activeSection = $('.dot-nav a[href="#'+$this.attr('id')+'"]').data('index') - 1;
            
			if ( ( $this.offset().top - $(window).height()/1.6 < $(window).scrollTop() ) && ( $this.offset().top + $this.height() - $(window).height()/1.6 > $(window).scrollTop() ) ) {
				navigationItems.eq(activeSection).addClass('current-dot');
			}else {
				navigationItems.eq(activeSection).removeClass('current-dot');
			}
		});
	}
  
  	var fromBot = $(document).height()-150-$(window).height();
  	 $(window).scroll(function(){
        if($(document).scrollTop() < fromBot && $(window).width() > 767) {
          $(".dot-nav").fadeIn(500);
        }else {
          $(".dot-nav").fadeOut(500);
        }
    });
  
  
  	// Read more
  	$('.more').hide();
    $('.read-more').on('click', function(e){
		e.preventDefault();
      	$(this).next().slideToggle();
    });
  
  
  
  

  
  
  
    
  
  	// Update price depending on product
   
//    if ($('.option[data-value="GBP"]').hasClass('selected')) {
  
    $('#ProductSelect').change(function(){
      
      $('.change-price').html($(this).find(':selected').data('price'));

      $('.currency-switcher .option.selected').trigger('click');
      
    }).trigger('change');
  
  
    // Expand how it works layers
  if ($('#sectionfour').length) {
    
    expand_layers();
    $(window).scroll(expand_layers);
    
  }

    function expand_layers(){
      if($(document).scrollTop() > $('#sectionfour').position().top - 200) {
        $('#sectionfour .section-image').addClass('expanded-layers');
      }
    }
  
  
  
  // How it works
  
  var orig = $('.original-content').html();
  
  $('.hotspot').on('click', function(){

    	$('*').removeClass('scale-small');
    
    
        if ($(this).hasClass('current-tip')) {
          
            $('img').removeClass('faded-layer');
            $('*').removeClass('current-tip').removeClass('scale-small');
          	
          	$('#sectionfour .section-content').fadeOut(250, function() {
          		$('#sectionfour .section-content').html(orig).fadeIn(250);
            });
          
        } else {
          
            $('.layer').removeClass('faded-layer');
            $('.layer').removeClass('current-tip');

            $(this).siblings().removeClass('current-tip');

            var tip_data = $(this).data('tip');

            var tip = $('.'+tip_data).html();

            $('.'+tip_data+', *[data-tip="'+tip_data+'"]').addClass('current-tip').siblings().addClass('scale-small');

            $('#sectionfour .section-content').fadeOut(250, function() {
                $(this).html(tip).fadeIn(250);
            });

            $('img.current-tip').siblings().addClass('faded-layer');
    
        }

    
  });
  
  
  
   
   
   
   
  
  
//     $('.next-tip').on('click', function(){

//       if ($('.current-tip').hasClass('tip-five')) {
//           $('.current-tip').hide().removeClass('current-tip');
//           $('.tip').first().addClass('current-tip')
//       } else {
//           $('.current-tip').hide().removeClass('current-tip').next().addClass('current-tip');
//       }

//       $('.current-tip').show();

//     });

//     $('.prev-tip').on('click', function(){

//       if ($('.current-tip').hasClass('tip-one')) {
//           $('.current-tip').hide().removeClass('current-tip');
//           $('.tip').last().addClass('current-tip')
//       } else {
//           $('.current-tip').hide().removeClass('current-tip').prev().addClass('current-tip');
//       }

//       $('.current-tip').show();

//     });
  
   
   
   
   

 
  // Fade in on scroll
  $(window).scroll( function(){
    
    /* Check the location of each desired element */
    $('.hideme').each( function(i){

      var bottom_of_object = $(this).offset().top + $(this).outerHeight();
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      /* If the object is completely visible in the window, fade it it */
      if( bottom_of_window > bottom_of_object ){

        $(this).animate({'opacity':'1'},500);

      }

    }); 
    
  });
  

//    $('.size-guide-button').on('click', function(e){
//    		e.preventDefault();
//      	$('.size-guide').slideToggle();     
//    });

//    $('.shipping-button').on('click', function(e){
//    		e.preventDefault();
//      	$('.shipping').slideToggle();     
//    });
   
   
   
   $(window).on('resize', layers_resize);
   
   function layers_resize(){
     
     if ($(this).width() < 1300) {
   	
       var height_layers = $('.layer').height();
       $('.expanded-layers').css('height', height_layers);
       
     } else {
      
       $('.expanded-layers').css('height', '100%');
       
     }
     
   	var height_layers = $('.layer').height();
    $('.layers-wrap').css('height', height_layers);
    	
   }

   
     /*
     * @author  Mudit Ameta
     * @license https://github.com/zeusdeux/isInViewport/blob/master/license.md MIT
     */
    !function(a,b){function c(b){var c,d=a("<div></div>").css({width:"100%"});return b.append(d),c=b.width()-d.width(),d.remove(),c}function d(e,f){var g=e.getBoundingClientRect(),h=g.top,i=g.bottom,j=g.left,k=g.right,l=a.extend({tolerance:0,viewport:b},f),m=!1,n=l.viewport.jquery?l.viewport:a(l.viewport);n.length||(console.warn("isInViewport: The viewport selector you have provided matches no element on page."),console.warn("isInViewport: Defaulting to viewport as window"),n=a(b));var o=n.height(),p=n.width(),q=n[0].toString();if(n[0]!==b&&"[object Window]"!==q&&"[object DOMWindow]"!==q){var r=n[0].getBoundingClientRect();h-=r.top,i-=r.top,j-=r.left,k-=r.left,d.scrollBarWidth=d.scrollBarWidth||c(n),p-=d.scrollBarWidth}return l.tolerance=~~Math.round(parseFloat(l.tolerance)),l.tolerance<0&&(l.tolerance=o+l.tolerance),0>=k||j>=p?m:m=l.tolerance?h<=l.tolerance&&i>=l.tolerance:i>0&&o>=h}String.prototype.hasOwnProperty("trim")||(String.prototype.trim=function(){return this.replace(/^\s*(.*?)\s*$/,"$1")});var e=function(b){if(1===arguments.length&&"function"==typeof b&&(b=[b]),!(b instanceof Array))throw new SyntaxError("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions");for(var c=0;c<b.length;c++)if("function"==typeof b[c])for(var d=0;d<this.length;d++)b[c].call(a(this[d]));else console.warn("isInViewport: Argument(s) passed to .do/.run should be a function or an array of functions"),console.warn("isInViewport: Ignoring non-function values in array and moving on");return this};a.fn["do"]=function(a){return console.warn("isInViewport: .do is deprecated as it causes issues in IE and some browsers since it's a reserved word. Use $.fn.run instead i.e., $(el).run(fn)."),e(a)},a.fn.run=e;var f=function(b){if(b){var c=b.split(",");return 1===c.length&&isNaN(c[0])&&(c[1]=c[0],c[0]=void 0),{tolerance:c[0]?c[0].trim():void 0,viewport:c[1]?a(c[1].trim()):void 0}}return{}};a.extend(a.expr[":"],{"in-viewport":a.expr.createPseudo?a.expr.createPseudo(function(a){return function(b){return d(b,f(a))}}):function(a,b,c){return d(a,f(c[3]))}}),a.fn.isInViewport=function(a){return this.filter(function(b,c){return d(c,a)})}}(jQuery,window);
   
  $('video:not(#newvid)').each(function(){
      
      if ($(this).is(":in-viewport")) {
          $(this)[0].play();
      } else {
          $(this)[0].pause();
      }
    })
   
  
    
    
    
      
  $(window).load(function() {

      var lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazy"
      });
    
        
   lazyLoadInstance.loadAll();
  });
  
  
  

    
       	layers_resize();
        var height_layers = $('.layer').height();
        $('.layers-wrap').css('height', height_layers);
                
    
  
// $.getJSON( "https://reallyfreegeoip.org/json/?callback=", function( data ) {
//   let country = data.country_code;
//   if (country == 'US' || country == 'CA') {
//     window.location.href = 'https://www.n-pro.us/';
//   } else if (country == 'AU' || country == 'NZ') {
//     window.location.href = 'https://www.n-pro.com.au/';
//   }
// })
  
  
});